export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-12.jpg'),
        title: '数据化变革',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '数字革命是完整的模式转变',
      description: `<p style="font-size:1.05rem">由于技术发展，世界已经发生了深刻的变化，无论您的业务领域如何，与最新技术保持同步是成功的关键。就像之前的工业革命一样，数字革命是一个完整的范例 转移。 新技术迅速出现，它们成为所有公司成功之路上非常重要的一步。 AI，IoT，区块链，大数据。 所有这些不仅仅是关键词，而是非常重要的技术，它们是我们生活各方面不可或缺的一部分，包括商业领域。 Digital可以改变您运营公司的方式，预测方式和产品销售方式，并确保您不会落后对于保持
与今天的数字全球经济息息相关。
</p><p>​​MaesInfo可以成为您企业IT解决方案的强大合作伙伴。 MaesInfo顾问与包括财富500强公司在内的众多行业合作，为公司创建定制，全面的解决方案。我们提供公司在软件工程方面的丰富经验，帮助您为数字时代做好准备。 无论您是需要服务数字化，电子商务业务协助，软件开发还是集成，MaesInfo都有为您的公司选择合适的IT解决方案的经验。</p>`
    },
    {
      title: '​​MaesInfo提供广泛的解决方案，重点关注质量和成本效益的实施：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-12.jpg')+`)"></span>
      <span class="list">
      <i></i>发展公司的IT基础设施<br/>
      <i></i>服务数字化<br/>
     <i></i>协助您的业务

      </span>`
    }
  ]
}
